import React, { KeyboardEventHandler, useRef } from 'react';
import DatePicker from 'react-datepicker';
import { InputGroup, InputGroupAddon } from 'reactstrap';
import { faCalendarAlt, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface DateInputProps {
    value?: string;
    onClick?: () => void;
    onKeyDown?: KeyboardEventHandler<HTMLButtonElement>;
    'aria-label'?: string;
}

const DateInput = React.forwardRef<HTMLButtonElement, DateInputProps>(
    ({ value, onClick, onKeyDown, 'aria-label': ariaLabel }, ref) => (
        <button
            type="button"
            ref={ref}
            className="btn ff-payoffs__date-input"
            aria-label={ariaLabel}
            onClick={onClick}
            onKeyDown={onKeyDown}>
            {value || 'Select a date'}
        </button>
    )
);

export interface PayoffTableDatePickerProps {
    selected: Date | null;
    label: string;
    onChange: (nextValue: Date | null) => void;
}

export const PayoffTableDatePicker = ({ selected, label, onChange }: PayoffTableDatePickerProps) => {
    const datePickerRef = useRef<any>(null);

    return (
        <InputGroup className="ff-payoffs__date-picker">
            <InputGroupAddon
                addonType="prepend"
                onClick={() => datePickerRef.current?.setOpen(true)}>
                <div className="input-group-text">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
            </InputGroupAddon>
            <DatePicker
                ref={datePickerRef}
                selected={selected}
                onChange={(value: Date | null) => onChange(value)}
                dateFormat="MM/dd/yyyy"
                popperProps={{ strategy: 'fixed' }}
                customInput={<DateInput aria-label={label} />}
            />
            {selected && (
                <button
                    type="button"
                    className="ff-payoffs__date-clear"
                    title={`Clear ${label.toLowerCase()}`}
                    aria-label={`Clear ${label.toLowerCase()}`}
                    onClick={() => onChange(null)}>
                    <FontAwesomeIcon icon={faXmark} />
                </button>
            )}
        </InputGroup>
    );
};
